import { useEffect, useRef, useState } from 'react'

export function usePullToRefresh(onRefresh, threshold = 80) {
  const [isPulling, setIsPulling] = useState(false)
  const [pullDistance, setPullDistance] = useState(0)
  const startY = useRef(0)
  const scrollableRef = useRef(null)

  useEffect(() => {
    const element = scrollableRef.current || window

    const handleTouchStart = (e) => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      if (scrollTop === 0) {
        startY.current = e.touches[0].clientY
      }
    }

    const handleTouchMove = (e) => {
      if (startY.current === 0) return

      const scrollTop = window.scrollY || document.documentElement.scrollTop
      if (scrollTop > 0) {
        startY.current = 0
        setPullDistance(0)
        setIsPulling(false)
        return
      }

      const currentY = e.touches[0].clientY
      const distance = currentY - startY.current

      if (distance > 0) {
        setIsPulling(true)
        setPullDistance(Math.min(distance, threshold * 1.5))
      }
    }

    const handleTouchEnd = async () => {
      if (pullDistance >= threshold) {
        try {
          await onRefresh()
        } catch (error) {
          console.error('Refresh failed:', error)
        }
      }

      startY.current = 0
      setPullDistance(0)
      setIsPulling(false)
    }

    document.addEventListener('touchstart', handleTouchStart, { passive: true })
    document.addEventListener('touchmove', handleTouchMove, { passive: true })
    document.addEventListener('touchend', handleTouchEnd)

    return () => {
      document.removeEventListener('touchstart', handleTouchStart)
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('touchend', handleTouchEnd)
    }
  }, [onRefresh, pullDistance, threshold])

  return {
    isPulling,
    pullDistance,
    isRefreshing: isPulling && pullDistance >= threshold,
  }
}
